import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { APP_CONFIG } from 'app/core/config/app-config.token';
import { catchError, map, Observable, throwError } from 'rxjs';
import { EsqepBuildVersionsResponse } from '../../models/build-versions/esqep-build-versions-response';

@Injectable({
  providedIn: 'root',
})
export class BuildVersionsService {
  private http = inject(HttpClient);
  private readonly appConfig = inject(APP_CONFIG);

  private get dotNetServerUri(): string {
    return this.appConfig.serverUrl;
  }

  getBuildVersions(): Observable<EsqepBuildVersionsResponse> {
    return this.http
      .get<
        EsqepBuildVersionsResponse
      >(`${this.dotNetServerUri}/buildVersions`)
      .pipe(
        map((resp) => resp),
        catchError((err) => {
          return throwError(() => new Error(err))
        }),
      );
  }
}
